import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { createErrorHandler } from '@sentry/angular';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { planAvisoInterceptor } from './core/interceptors/plan-aviso.interceptor';
import { tenantInterceptor } from './core/interceptors/tenant.interceptor';
import { mockInterceptor } from './core/interceptors/mock.interceptor';

/**
 * Salvaguarda: el mockInterceptor devuelve datos inventados para Pagos a Proveedores.
 * Es una herramienta de desarrollo legítima (`npm run start:mock`), pero si alguna vez
 * se buildea producción con la configuración equivocada, la aplicación entera responde
 * con datos falsos SIN AVISAR. Un comercio operando sobre datos falsos es peor que una
 * aplicación caída, así que acá se corta de entrada.
 */
if (environment.production && environment.mockMode) {
  throw new Error(
    '[CONFIG] Build de producción con mockMode activado. ' +
    'El mockInterceptor devolvería datos falsos a un comercio real. ' +
    'Revisá src/environments/ y la configuración de build.'
  );
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      // anchorScrolling: los links de Ayuda del sidebar navegan a anclas (#faq,
      // #modulos). Sin esto, Angular cambia la URL pero no hace scroll.
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })
    ),
    provideHttpClient(
      withInterceptors([mockInterceptor, authInterceptor, tenantInterceptor, errorInterceptor, planAvisoInterceptor])
    ),
    // Manda a Sentry los errores no atrapados (sin DSN, Sentry no está iniciado y no hace nada)
    // y los sigue mostrando en la consola como el ErrorHandler de Angular.
    { provide: ErrorHandler, useValue: createErrorHandler() }
  ]
};
